/* eslint-disable no-undef */
export const useConfiguratorStore = defineStore("configurator", () => {
  // STATE ------------------------------------------------------------------

  const mobileBreakpoint = ref(768); // @TODO: Move to global store
  const minVisibleFraction = ref(0.3);
  const isSaving = ref(false);
  const isAddingToCart = ref(false);

  // Drawer
  const activeDrawerComponentIndex = ref(0);
  const checkedDrawer = ref(false);

  // Sliding panels
  const isEditorFullscreen = ref(false);
  const isPreviewFullscreen = ref(false);

  // Zoom
  const zoomInEnabled = ref(true);
  const zoomOutEnabled = ref(true);
  const canvasContainerScale = ref(1);

  // Theme
  const isShiftDown = ref(false);
  const isMetaKeyDown = ref(false);

  // ACTIONS ----------------------------------------------------------------
  function setIsEditorFullscreen(payload) {
    isEditorFullscreen.value = payload;
  }
  function setIsSaving(payload) {
    isSaving.value = payload;
  }
  function setIsAddingToCart(payload) {
    isAddingToCart.value = payload;
  }
  function setIsPreviewFullscreen(payload) {
    isPreviewFullscreen.value = payload;
  }
  function setIsShiftDown(payload) {
    isShiftDown.value = payload;
  }
  function setIsMetaKeyDown(payload) {
    isMetaKeyDown.value = payload;
  }
  function showTextDrawer() {
    activeDrawerComponentIndex.value = 1;
  }
  function showImagesDrawer() {
    activeDrawerComponentIndex.value = 2;
  }
  function showBackgroundDrawer() {
    activeDrawerComponentIndex.value = 3;
  }
  function showShapesDrawer() {
    activeDrawerComponentIndex.value = 4;
  }
  function showSettingsDrawer() {
    activeDrawerComponentIndex.value = 5;
  }
  function showDrawer(payload) {
    checkedDrawer.value = !!payload;
  }
  function closeDrawer() {
    checkedDrawer.value = false;
    activeDrawerComponentIndex.value = 0;
  }
  return {
    activeDrawerComponentIndex,
    checkedDrawer,
    isEditorFullscreen,
    isPreviewFullscreen,
    zoomInEnabled,
    zoomOutEnabled,
    canvasContainerScale,
    isShiftDown,
    isMetaKeyDown,
    mobileBreakpoint,
    minVisibleFraction,
    isSaving,
    isAddingToCart,
    showDrawer,
    setIsSaving,
    setIsAddingToCart,
    closeDrawer,
    showTextDrawer,
    showImagesDrawer,
    showBackgroundDrawer,
    showShapesDrawer,
    showSettingsDrawer,
    setIsEditorFullscreen,
    setIsPreviewFullscreen,
    setIsShiftDown,
    setIsMetaKeyDown
  };
});